@if (label) {
  <div class="label">{{ label }}</div>
}
<div class="date-picker-wrapper" [ngStyle]="{'margin': customMargin}">
  @if (mode === 'range') {
    <nz-range-picker
      [(ngModel)]="value"
      [nzSize]="size"
      [nzPlaceHolder]="getRangePlaceholder()"
      [nzDisabled]="disabled"
      [nzDisabledDate]="(minDate || maxDate) ? getDisabledDate : undefined"
      [ngStyle]="{'width': customWidth}"
      [nzInputReadOnly]="true"
      (ngModelChange)="onValueChange($event)"
      (nzOpenChange)="onOpenChange($event)"
    />
  } @else if (mode === 'range-month') {
    <nz-range-picker
      [(ngModel)]="value"
      [nzSize]="size"
      [nzMode]="'month'"
      [nzPlaceHolder]="getRangePlaceholder()"
      [nzDisabled]="disabled"
      [nzDisabledDate]="(minDate || maxDate) ? getDisabledDate : undefined"
      [ngStyle]="{'width': customWidth}"
      [nzInputReadOnly]="true"
      (ngModelChange)="onValueChange($event)"
      (nzOpenChange)="onOpenChange($event)"
    />
  } @else if (mode === 'date') {
    <nz-date-picker
      [(ngModel)]="value"
      [nzSize]="size"
      [nzPlaceHolder]="placeholder"
      [nzDisabled]="disabled"
      [ngStyle]="{'width': customWidth}"
      [nzInputReadOnly]="true"
      [nzDisabledDate]="disabledDate"
      [nzShowToday]="false"
      (ngModelChange)="onValueChange($event)"
      (nzOpenChange)="onOpenChange($event)"
    />
  }
</div>
